import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { AppConfig, AppConfiguration } from 'src/configuration';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ThongTinNhapHocService {
  constructor(
    @Inject(AppConfig) private readonly appConfig: AppConfiguration,
    private router: Router,
    private http: HttpClient
  ) {}
  getList(ID_he: any, Nam_hoc: any, ID_nganh: any): Observable<any> {
    return this.http
      .get<any>(
        this.appConfig.UniLeader +
          '/api/ThongTinNhapHoc?ID_he=' +
          ID_he +
          '&Nam_hoc=' +
          Nam_hoc +
          '&ID_nganh=' +
          ID_nganh
      )
      .pipe(
        map((z) => {
          return z;
        })
      );
  }
}
